import { toast } from 'react-toastify';

import { callApi } from '../../../../../../apiCaller';
import { isOrgUser, toastError } from '../../../../../../utils';
import { API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_DETAIL, COURSE_DIRECT_PATH, MY_LEARNING_ROUTES, MY_ORG_ROUTES } from '../../../../../../constants';

import { addProfileUser } from '../../../../Subscriber/AccountSettings/actions';
import { setIsLoading } from '../../../../../../actions/general';
import { setSubscriberUser } from '../../../../Subscriber/GlobalStates/CurrentUser/actions';
import { setUserProfessionalField, setUserProfessionalFieldLicense } from '../../../../Subscriber/GlobalStates/UserProfessional/actions';

const API_SUBSCRIBER_PROFESSIONAL_DETAIL = 'user/professional-field/professional-details';

export const setUserProfessionalFieldLicenseResponse = (responseData) => (dispatch) => {
     const newUserProfessionalFieldLicense = {};
     if (responseData?.length > 0) {
          if (responseData.length === 1 && responseData[0].country !== 'US') {
               newUserProfessionalFieldLicense.country = responseData[0]?.country;
               newUserProfessionalFieldLicense.name = responseData[0]?.name;
               newUserProfessionalFieldLicense.licenseID = responseData[0]?.licenseID;
               newUserProfessionalFieldLicense.expiredAt = responseData[0]?.expiredAt;
               dispatch(setUserProfessionalFieldLicense(newUserProfessionalFieldLicense));
               return;
          }
          newUserProfessionalFieldLicense.country = responseData[0]?.country;
          newUserProfessionalFieldLicense.states = responseData.map((data) => data.state);
          newUserProfessionalFieldLicense.stateLicenseIDs = responseData.map((data) => {
               const stateLicenseId = {
                    id: data.id,
                    state: data.state,
                    licenseID: data.licenseID,
                    expiredAt: data.expiredAt,
               };
               return stateLicenseId;
          });
     }

     dispatch(setUserProfessionalFieldLicense(newUserProfessionalFieldLicense));
};

export const fetchSubscriberMyProfessionalRequest = () => (dispatch, getState) => {
     const user = getState().subscriber.user;

     if (!user?.id) return;

     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_DETAIL.replace(':userId', user.id), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setUserProfessionalField(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const addSubscriberMyProfessionalRequest = (nextDispatch) => (dispatch, getState) => {
     const { navigate, values } = nextDispatch;
     const profileUser = getState().subscriber.profileUser;

     callApi(API_SUBSCRIBER_PROFESSIONAL_DETAIL, 'PUT', values).then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const { user, userProfessionalField, userProfessionalFieldLicensee } = response.data;

          if (user) {
               dispatch(setSubscriberUser(user));

               if (profileUser) {
                    const { email, firstName, lastName, country, timezone } = user;
                    dispatch(addProfileUser({ ...profileUser, email, firstName, lastName, country, timezone }));
               }
          }
          if (userProfessionalField) {
               dispatch(setUserProfessionalField(userProfessionalField));
          }
          if (userProfessionalFieldLicensee) {
               dispatch(setUserProfessionalFieldLicenseResponse(userProfessionalFieldLicensee));
          }

          const localPath = localStorage.getItem(COURSE_DIRECT_PATH);
          let navigatePath = isOrgUser() ? MY_ORG_ROUTES : MY_LEARNING_ROUTES;
          if (localPath) navigatePath = localPath;

          navigate(navigatePath, { replace: true });
          localStorage.removeItem(COURSE_DIRECT_PATH);
          toast.success('Update successfully');
     });
};
